import React, { memo } from 'react'
import dynamic from 'next/dynamic'

// Lazily load DatesRangePicker component
const DatesRangePicker = dynamic(() => import('../DatesRangePicker'), {
  ssr: false,
  loading: () => null
})

const Dates = memo(
  ({
    form: { setFieldValue, values },
    shadowRef,
    setCalendarActive,
    custom,
    icon = false,
    translations,
    width
  }) => {
    return (
      <DatesRangePicker
        form={{ setFieldValue, values }}
        shadowRef={shadowRef}
        setCalendarActive={setCalendarActive}
        custom={custom}
        icon={icon}
        translations={translations}
        width={width}
      />
    )
  }
)

// Display name for debugging
Dates.displayName = 'Dates'

export default Dates
